'use strict';

const SELECTOR = '.donation-panel';

export default function () {
    document.querySelectorAll(SELECTOR).forEach(element => {
        const otherAmountBtn = element.querySelector('#other');
        const lowValueError = element.querySelector('.donation-panel__invalid');
        const submitBtn = element.querySelector('.donation-panel__btn');
        const minimumAmount = parseInt(element.dataset.minimumAmount, 10) || 10;

        if (otherAmountBtn) {
            otherAmountBtn.addEventListener('click', () => {
                element.querySelector('.donation-panel__specific-amount').classList.add('hidden');
                element.querySelector('.donation-panel__other-amount').classList.remove('hidden');

                element.querySelectorAll('[type="radio"]').forEach(radio => {
                    radio.required = false;
                });

                element.querySelector('[type="number"]').required = true;
            });
        }

        element.querySelector('.donation-panel__other-amount input')?.addEventListener('input', event => {
            const value = parseInt(event.target.value, 10);

            if (isNaN(value) || value < minimumAmount) {
                lowValueError?.classList.remove('is-hidden');
                submitBtn && (submitBtn.disabled = true);
            } else {
                lowValueError?.classList.add('is-hidden')
                submitBtn && (submitBtn.disabled = false);
            }
        });

        element.addEventListener('submit', event => {
            event.preventDefault();

            const amountField = element.querySelector('.donation-panel__specific-amount:not(.hidden) input:checked, .donation-panel__other-amount:not(.hidden) input');

            if (!amountField) {
                return alert('Please select/specify a donation amount');
            }

            const amount = parseInt(amountField.value, 10);

            if (!amount) {
                return alert('Please select/specify a valid donation amount');
            }

            if (amount < minimumAmount) {
                lowValueError?.classList.remove('is-hidden');
                return alert(`Minimum donation amount is $${minimumAmount}`);
            }

            window.location.href = decodeURI(event.target.action).replace('{amount}', amount);
        });
    });
}
